import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CommonService } from "../../../../services/CommonService";
import { FraudService } from "../../../../services/FraudService";
import moment from "moment";
moment.locale('es');

export const useFraudAdmin = (changeAlert: ChangeAlertCallbackType, handleGet, handleGetConfig, onCloseDialogAdd, onAddRegister, setErrorAdd, onCloseDialogCreate, onCreateConfig, redirectUpdateDialog, origin) => {
    const [title, setTitle] = useState('');
    const [active, setActive] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    
    const commonService = useRef<CommonService>();
    const fraudService = useRef<FraudService>();

    const init = async () => {
        setTitle('Actualizar estatus')
        setActive(false)
        setDisabled(true)
    }

    const updateStatus = async (request) => {
        setLoading(true);

        const response = await fraudService.current.fraudUpdate(request);        
        if(response.data?.response === 'OK'){
            setLoading(false);
            handleGet(true)
            changeAlert(true, 'success', 'El registro fue actualizado con éxito');
        } else {
            setLoading(false);
            changeAlert(true, 'error', response.data.message || 'El registro no pudo ser actualizado');
        }
    };

    const addRegister = async (request) => {
        setLoading(true);
        setErrorAdd(false)
        onCloseDialogAdd()
        const response = await fraudService.current.fraudAdd(request);        
        if(response.data?.response === 'OK'){
            setLoading(false);
            handleGet(true)
            changeAlert(true, 'success', 'El registro fue creado con éxito');
        } else {
            setErrorAdd(true)
            setLoading(false);
            onAddRegister()
            changeAlert(true, 'error', response.data.message || 'El registro no pudo ser creado');
        }
    };
    
    const createConfig = async (data) => {
        setLoading(true);
        setErrorAdd(false)
        onCloseDialogCreate()
        
        data['active'] = true
        setLoading(true);
        const response = await fraudService.current.fraudAccConfigAdd(data);
        if(response.data?.response === 'OK'){
            setLoading(false);
            handleGetConfig('configAcc')
            changeAlert(true, 'success', 'El registro fue creado con éxito');
        } else {
            setErrorAdd(true)
            setLoading(false);
            onCreateConfig()
            changeAlert(true, 'error', response.data.message || 'El registro no pudo ser creado');
        }
    };

    const updateConfig = async (data) => {
        setLoading(true);
        setErrorAdd(false)
        onCloseDialogCreate()

        setLoading(true);
        let request = {
            filters: {
                operation: data.operation,
                channel: data.channel
            },
            accumulator: {
                accumulators: data['accumulators'],
                field_expired: data['field_expired'],
                reboots: data['reboots'],
                active: data['active']
            }
        }

        if(origin === 'accumulator'){
            request.filters['entity_uuid'] = data['entity_uuid']
            request.accumulator['enabled'] = data['enabled']

            const response = await fraudService.current.fraudAccumulatorUpdate(request);
            if(response.data?.response === 'OK'){
                setLoading(false);
                handleGetConfig('accumulator')
                changeAlert(true, 'success', 'El registro fue actualizado con éxito');
            } else {
                setErrorAdd(true)
                setLoading(false);
                redirectUpdateDialog('configAcc', request, 'accumulator')
                changeAlert(true, 'error', response.data.message || 'El registro no pudo ser actualizado');
            }

        } else {
            const response = await fraudService.current.fraudAccConfigUpdate(request);
            if(response.data?.response === 'OK'){
                setLoading(false);
                handleGetConfig('configAcc')
                changeAlert(true, 'success', 'El registro fue actualizado con éxito');
            } else {
                setErrorAdd(true)
                setLoading(false);
                redirectUpdateDialog('configAcc', request)
                changeAlert(true, 'error', response.data.message || 'El registro no pudo ser actualizado');
            }
        }
    };

    useEffect(() => {
        commonService.current = new CommonService(changeAlert)
        fraudService.current = new FraudService(changeAlert)
        init()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading, active, disabled, title, updateStatus, addRegister, createConfig, updateConfig }

}
